import { FunctionComponent } from 'react';
import { useTitle } from 'react-use';

import { NeedHelp } from '@savgroup-front-common/core/components/NeedHelp';
import { buildPageTitle } from '@savgroup-front-common/core/helpers';
import { AuthConfiguration } from '@/configuration';
import { FINAL_ROUTES } from '@/view/app';
import BanneredLayout from '@/view/app/NewLayout/BanneredLayout/BanneredLayout';
import { ProductsInfo } from '@/view/components/ProductsInfo';

import messages from './messages';
import { useOrdersPage } from './OrdersPage.hooks';
import { $LayoutGrid } from './OrdersPage.styles';

const OrdersPages: FunctionComponent = () => {
  const { productsInfoAndHistoryList, handleShowProduct, newRequestRoute } =
    useOrdersPage();

  useTitle(buildPageTitle([messages.ordersTitlePage]));

  return (
    <>
      <NeedHelp clientId={AuthConfiguration.clientId} />
      <BanneredLayout>
        <BanneredLayout.BannerTitle
          breadcrumbs={[
            {
              label: messages.breadcrumbMyRequests,
              route: FINAL_ROUTES.PRODUCTS,
            },
          ]}
          title={messages.bannerTitle}
          description={messages.bannerDescription}
          actions={[
            {
              primary: true,
              label: messages.actionNewRequest,
              route: newRequestRoute,
            },
          ]}
        />
        <BanneredLayout.Content>
          <$LayoutGrid>
            {productsInfoAndHistoryList?.map(({ productsInfo, histories }) => {
              if (productsInfo) {
                return (
                  <ProductsInfo
                    key={productsInfo[0]?.fileReference}
                    productsInfo={productsInfo}
                    histories={histories}
                    hasHistory
                    onClick={() =>
                      handleShowProduct({ fileId: productsInfo[0].fileId })
                    }
                  />
                );
              }

              return null;
            })}
          </$LayoutGrid>
        </BanneredLayout.Content>
      </BanneredLayout>
    </>
  );
};

export default OrdersPages;
